import { inject, Inject, Injectable } from "@angular/core";
import * as AWS from "aws-sdk";
import { ENVIRONMENT } from "../environments/environments.token";
import { Environment } from "../environments/environment.interface";
import { UserManagementService } from "./user-management.service";
import { StorageHandlerService } from "./storage-handler.service";
import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { encrypt } from "@global-nodes/utilities/encrypt-decrypt";

@Injectable({
  providedIn: "root",
})
export class S3BucketService {
  private readonly userManagementService = inject(UserManagementService);
  private readonly storageHandlerService = inject(StorageHandlerService);
  private readonly handler = inject(HttpBackend);
  private env: Environment = inject(ENVIRONMENT);

  constructor() {
    this.httpClient = new HttpClient(this.handler);
  }

  private s3 = new AWS.S3();
  private httpClient: HttpClient;

  uploadFile(file: File, fileSize: number = 10) {
    // if (!this.env.awsCredentials) {
    //   alert("Configure AWS credentials in environment");
    //   return;
    // }
    // const bucketName = this.env.AWS_BUCKET_NAME;
    // const key = `${this.env.AWS_ROOT_URL}/${file.name}`;
    // AWS.config.update(this.env.awsCredentials);
    // this.s3 = new AWS.S3();
    // const params = {
    //   Bucket: bucketName || "kps-pd",
    //   Key: key,
    //   Body: file,
    //   ACL: this.env.AWS_ACL || "public-read", // Set appropriate permissions
    // };

    // return this.s3.upload(params).promise();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.storageHandlerService.getItem("token")}`,
      size: encrypt(fileSize, this.env.SECRET_KEY || "DEMO"),
    });

    const formData = new FormData();
    formData.append("file", file, file.name);
    return this.httpClient.post(`${this.env.USER_API}/api/file-upload/upload-single-file`, formData, { headers: headers }).toPromise();
  }

  deleteFile(fileName: string) {
    // if (!this.env.awsCredentials) {
    //   alert("Configure AWS credentials in environment");
    //   return;
    // }
    // const bucketName = this.env.AWS_BUCKET_NAME;
    // AWS.config.update(this.env.awsCredentials);
    // this.s3 = new AWS.S3();
    // const key = `${this.env.AWS_ROOT_URL}/${fileName}`;
    // const params = {
    //   Bucket: bucketName || "kps-pd",
    //   Key: key,
    // };
    // console.log("upload image service: deleteFile: param", params);
    // return this.s3.deleteObject(params).promise();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.storageHandlerService.getItem("token")}`,
      fileName: fileName,
    });
    return this.httpClient.delete(`${this.env.USER_API}/api/file-upload/delete-single-file`, { headers: headers }).toPromise();
  }
}
